import $ from 'jquery';
import constants from './constants';
import Audio from './audio';
import Ghost from './ghost';
import Map from './map';
import User from './user';

const FOOTER_BACKGROUND_FILL_STYLE = '#000000';

const DIALOG_FILL_STYLE = '#FFFFFF';
const SCORE_FILL_STYLE = '#FFFFFF';
const LEVEL_FILL_STYLE = '#FFFFFF';

const SOUND_ENABLED_FILL_STYLE = '#70E250';
const SOUND_DISABLED_FILL_STYLE = '#FC553F';

const game = (function () {
  let state = constants.WAITING;
  let audio = null;
  const ghosts = [];
  const ghostSpecs = ['#00FFDE', '#FF0000', '#FFB8DE', '#FFB847'];
  let eatenCount = 0;
  let level = 0;
  let tick = 0;
  let ghostPos;
  let userPos;
  let stateChanged = true;
  let timerStart = null;
  let lastTime = 0;
  let ctx = null;
  let timer = null;
  let map = null;
  let user = null;
  let stored = null;

  function setState(nState) {
    state = nState;
    stateChanged = true;
  }

  function getTick() {
    return tick;
  }

  function drawScore(text, position) {
    ctx.fillStyle = SCORE_FILL_STYLE;
    ctx.font = '12px BDCartoonShoutRegular';
    ctx.fillText(text,
      (position.new.x / 10) * map.blockSize,
      ((position.new.y + 5) / 10) * map.blockSize);
  }

  function dialog(text) {
    ctx.fillStyle = DIALOG_FILL_STYLE;
    ctx.font = '14px BDCartoonShoutRegular';
    const width = ctx.measureText(text).width;
    const x = ((map.width * map.blockSize) - width) / 2;
    ctx.fillText(text, x, (map.height * 10) + 8);
  }

  function soundDisabled() {
    return localStorage.getItem('soundDisabled') === 'true';
  }

  function startLevel() {
    user.resetPosition();
    for (let i = 0; i < ghosts.length; i += 1) {
      ghosts[i].reset();
    }
    audio.play('music');
    timerStart = tick;
    setState(constants.COUNTDOWN);
  }

  function startNewGame() {
    setState(constants.WAITING);
    level = 1;
    user.reset();
    map.reset();
    map.draw(ctx);
    startLevel();
    try { window.ga('send', 'event', 'Halloween', 'New Game'); } catch (exeption) {}
  }

  function gameOver() {
    setState(constants.WAITING);
    audio.stop('music');
  }

  function keyDown(e) {
    if (e.keyCode === constants.KEY.ESCAPE) {
      gameOver();
    } else if (e.keyCode === constants.KEY.SPACEBAR && state === constants.WAITING) {
      startNewGame();
    } else if (e.keyCode === constants.KEY.S) {
      if (soundDisabled()) {
        localStorage.removeItem('soundDisabled');
        audio.play('music');
      } else {
        localStorage.setItem('soundDisabled', 'true');
        audio.disableSound();
      }
    } else if (e.keyCode === constants.KEY.P && state === constants.PAUSE) {
      audio.resume();
      map.draw(ctx);
      setState(stored);
    } else if (e.keyCode === constants.KEY.P && state === constants.PLAYING) {
      stored = state;
      setState(constants.PAUSE);
      audio.pause();
      map.draw(ctx);
      dialog('Paused');
    } else if (state !== constants.PAUSE) {
      return user.keyDown(e);
    }
    return true;
  }

  function loseLife() {
    setState(constants.WAITING);
    user.loseLife();
    if (user.getLives() > 0) {
      startLevel();
    } else {
      gameOver();
    }
  }

  function collided(user, ghost) {
    return (Math.sqrt(Math.pow(ghost.x - user.x, 2) +
      Math.pow(ghost.y - user.y, 2))) < 10;
  }

  // @TODO: Move the footer to the header?
  function drawFooter() {
    const topLeft = (map.height * map.blockSize);
    const textBase = topLeft + 17;

    ctx.fillStyle = FOOTER_BACKGROUND_FILL_STYLE;
    ctx.fillRect(0, topLeft, (map.width * map.blockSize), 30);

    for (let i = 0, len = user.getLives(); i < len; i++) {
      ctx.fillStyle = '#FFFF00';
      ctx.beginPath();
      ctx.moveTo(150 + (25 * i) + map.blockSize / 2,
        (topLeft + 1) + map.blockSize / 2);

      ctx.arc(150 + (25 * i) + map.blockSize / 2,
        (topLeft + 1) + map.blockSize / 2,
        map.blockSize / 2, Math.PI * 0.25, Math.PI * 1.75, false);
      ctx.fill();
    }

    // Sound (on/off).
    ctx.fillStyle = !soundDisabled() ? SOUND_ENABLED_FILL_STYLE : SOUND_DISABLED_FILL_STYLE;
    ctx.font = 'bold 16px sans-serif';
    ctx.fillText('♪', 10, textBase);

    // Score + Level
    ctx.font = '14px BDCartoonShoutRegular';
    ctx.fillStyle = SCORE_FILL_STYLE;
    ctx.fillText(`Score: ${user.theScore()}`, 30, textBase);
    ctx.fillStyle = LEVEL_FILL_STYLE;
    ctx.fillText(`Level: ${level}`, 260, textBase);
  }

  function redrawBlock(pos) {
    map.drawBlock(Math.floor(pos.y / 10), Math.floor(pos.x / 10), ctx);
    map.drawBlock(Math.ceil(pos.y / 10), Math.ceil(pos.x / 10), ctx);
  }

  function mainDraw() {
    let diff,
      u,
      i,
      len,
      nScore;

    ghostPos = [];

    for (i = 0, len = ghosts.length; i < len; i += 1) {
      ghostPos.push(ghosts[i].move(ctx));
    }
    u = user.move(ctx);

    for (i = 0, len = ghosts.length; i < len; i += 1) {
      redrawBlock(ghostPos[i].old);
    }
    redrawBlock(u.old);

    for (i = 0, len = ghosts.length; i < len; i += 1) {
      ghosts[i].draw(ctx);
    }
    user.draw(ctx);

    userPos = u.new;

    for (i = 0, len = ghosts.length; i < len; i += 1) {
      if (collided(userPos, ghostPos[i].new)) {
        if (ghosts[i].isVunerable()) {
          audio.play('eatghost');
          ghosts[i].eat();
          eatenCount += 1;
          nScore = eatenCount * 50;
          drawScore(nScore, ghostPos[i]);
          user.addScore(nScore);
          setState(constants.EATEN_PAUSE);
          timerStart = tick;
        } else if (ghosts[i].isDangerous()) {
          audio.play('die');
          setState(constants.DYING);
          timerStart = tick;
        }
      }
    }
  }

  function mainLoop() {
    let diff;

    if (state !== constants.PAUSE) {
      tick += 1;
    }

    map.drawPills(ctx);

    if (state === constants.PLAYING) {
      mainDraw();
    } else if (state === constants.WAITING && stateChanged) {
      stateChanged = false;
      map.draw(ctx);
      dialog('Press spacebar to start');
    } else if (state === constants.EATEN_PAUSE && (tick - timerStart) > (constants.FPS / 3)) {
      map.draw(ctx);
      setState(constants.PLAYING);
    } else if (state === constants.DYING) {
      if (tick - timerStart > (constants.FPS * 2)) {
        loseLife();
      } else {
        redrawBlock(userPos);
        for (let i = 0, len = ghosts.length; i < len; i += 1) {
          redrawBlock(ghostPos[i].old);
          ghostPos.push(ghosts[i].draw(ctx));
        }
        user.drawDead(ctx, (tick - timerStart) / (constants.FPS * 2));
      }
    } else if (state === constants.COUNTDOWN) {
      diff = 5 + Math.floor((timerStart - tick) / constants.FPS);

      if (diff === 0) {
        map.draw(ctx);
        setState(constants.PLAYING);
      } else if (diff !== lastTime) {
        lastTime = diff;
        map.draw(ctx);
        dialog(`Starting in: ${diff}`);
      }
    }

    drawFooter();
  }

  function eatenPill() {
    audio.play('eatpill');
    timerStart = tick;
    eatenCount = 0;
    for (let i = 0; i < ghosts.length; i += 1) {
      ghosts[i].makeEatable(ctx);
    }
  }

  function completedLevel() {
    setState(constants.WAITING);
    level += 1;
    map.reset();
    user.newLevel();
    startLevel();
  }

  function keyPress(e) {
    if (state !== constants.WAITING && state !== constants.PAUSE) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  function load(arr, callback) {
    if (arr.length === 0) {
      callback();
    } else {
      const x = arr.pop();
      audio.load(x[0], x[1], () => { load(arr, callback); });
    }
  }

  function loaded() {
    dialog('Press N to Start');

    document.addEventListener('keydown', keyDown, true);
    document.addEventListener('keypress', keyPress, true);

    timer = window.setInterval(mainLoop, 1000 / constants.FPS);
  }

  function init(wrapper) {
    const blockSize = wrapper.offsetWidth / 19;
    const canvas = document.createElement('canvas');

    canvas.setAttribute('width', `${blockSize * 19}px`);
    canvas.setAttribute('height', `${(blockSize * 22) + 30}px`);

    wrapper.appendChild(canvas);

    ctx = canvas.getContext('2d');

    audio = new Audio({ soundDisabled });
    map = new Map(blockSize);
    user = new User({
      completedLevel,
      eatenPill,
    }, map);

    for (let i = 0, len = ghostSpecs.length; i < len; i += 1) {
      const ghost = new Ghost({ getTick }, map, ghostSpecs[i]);
      ghosts.push(ghost);
    }

    map.draw(ctx);
    dialog('Loading ...');

    const extension = 'mp3';
    const audioFiles = [
      ['music', `/static/audio/music.${extension}`],
      ['start', `/static/audio/music.${extension}`],
      ['die', `/static/audio/die.${extension}`],
      ['eatghost', `/static/audio/eatghost.${extension}`],
      ['eatpill', `/static/audio/eatpill.${extension}`],
      ['eating', `/static/audio/eating-short.${extension}`],
      ['eating2', `/static/audio/eating-short.${extension}`],
    ];

    load(audioFiles, loaded);

    // Toggle sound on click of the canvas.
    // @TODO: Check if its within a small hitbox on top of the sound icon.
    $(canvas).on('click', () => {
      keyDown({
        keyCode: constants.KEY.S,
      });
    });
  }

  return {
    init,
  };
}());

module.exports = game;



// WEBPACK FOOTER //
// ./_components/hero-halloween-block/game.js